import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const Pricing = () => {
  const location = useLocation()

  useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb4b');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  },[])

  return (
    <div className="page-wrapper" data-w-id="67e0efe8817933cee2c1c63b" style={{"opacity":"0"}}>
      <Navbar />
      <section class="section inner-banner">
        <div class="inner-banner-content">
          <div class="inner-banner-wrapper">
            <div class="container">
              <div class="inner-banner-typography">
                <div class="inner-banner-subtitle-wrap">
                  <div class="inner-banner-subtitle">Pricing plan</div>
                </div>
                 <div class="inner-banner-title-wrapper">
                  <h1 class="inner-banner-title contact-us">Flexible pricing plans that <br /> allow anyone accessibility. </h1>
                  <p class="inner-banner-description">Fast, seamless, & instant access with multiple payment options</p>
                </div>
              </div>
            </div><img src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
              class="inner-banner-pluse-icon top-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                loading="lazy" alt="" class="inner-banner-pluse-icon top-right" /><img
              src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
              class="inner-banner-pluse-icon bottom-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                loading="lazy" alt="" class="inner-banner-pluse-icon bottom-right" />
          </div>
        </div>
      </section>
      <section class="section pricing">
        <div class="container">
          <div data-w-id="f13a2526-f0af-73c7-8496-0928182a1d05" style={{ "opacity": "1" }} class="pricing-content">
            <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100"
              class="pricing-tabs w-tabs">
              <div class="pricing-tabs-menu w-tab-menu"><a data-w-tab="Tab 1"
                class="pricing-tab-link w-inline-block w-tab-link w--current">
                <div>billing monthly</div>
              </a>
              {/* <a data-w-tab="Tab 2" class="pricing-tab-link w-inline-block w-tab-link">
                  <div>billing yearly</div>
                </a> */}
                </div>
              <div class="pricing-tabs-content w-tab-content">
                <div data-w-tab="Tab 1" class="pricing-tabs-pane w-tab-pane w--tab-active">
                  <div class="pricing-wrapper">
                    <div class="w-layout-grid pricing-grid">
                      <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon1.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Silver Plan</h5>
                                      {/* <div class="pricing-short-details-text">Needs to become Silver Plan</div> */}
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$159.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Personal Development Education</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Financial Literacy Education</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Financial Journal</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Social Community App</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Nootropic Coffee</div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="#"
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon2.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Gold Plan</h5>
                                      {/* <div class="pricing-short-details-text">Needs to become Gold Plan</div> */}
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$259.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Personal Development Education </div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Financial Literacy Education</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Artificial Intelligence Education</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Financial Journal</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Social Community App</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Nootropic Coffee</div>
                                      </li>
                                      {/* <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Unlimited Stock Graphics</div>
                                      </li> */}
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="#" 
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon3.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Enterprise Plan</h5>
                                      <div class="pricing-short-details-text">Best for large enterprises</div>
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$320.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">1 page with multiple sections</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">3 — 10 days turnaround</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">First sketch in 24 hours</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Figma Design + Development</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Responsive (4 breakpoints)</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">SEO-optimized</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Unlimited Stock Graphics</div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="/product/enterprise-plan"
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    </div>
                  </div>
                </div>
                <div data-w-tab="Tab 2" class="pricing-tabs-pane w-tab-pane">
                  <div class="pricing-wrapper">
                    <div class="w-layout-grid pricing-grid">
                      <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon1.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Personal Plan</h5>
                                      <div class="pricing-short-details-text">Good for personal freelance</div>
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$230.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">1 page with multiple sections</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">3 — 10 days turnaround</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">First sketch in 24 hours</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Figma Design + Development</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Responsive (4 breakpoints)</div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="/product/personal-plan"
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon2.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Premium Plan</h5>
                                      <div class="pricing-short-details-text">Good for small business</div>
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$340.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">1 page with multiple sections</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">3 — 10 days turnaround</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">First sketch in 24 hours</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Figma Design + Development</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Responsive (4 breakpoints)</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">SEO-optimized</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Unlimited Stock Graphics</div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="/product/premium-plan"
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pricing-card-wrap">
                        <div class="pricing-collection-list-wrapper w-dyn-list">
                          <div role="list" class="pricing-collection-list w-dyn-items">
                            <div role="listitem" class="pricing-collection-item w-dyn-item">
                              <div class="pricing-single">
                                <div class="pricing-top-content">
                                  <div class="pricing-image-name-wrap">
                                    <div class="pricing-icon-wrapper"><img
                                      data-wf-sku-bindings="%5B%7B%22from%22%3A%22f_main_image_4dr%22%2C%22to%22%3A%22src%22%7D%5D"
                                      loading="lazy" alt="" src="images/pricing-20icon3.png" class="pricing-icon" />
                                    </div>
                                    <div class="pricing-name-short-text">
                                      <h5 class="pricing-name">Enterprise Plan</h5>
                                      <div class="pricing-short-details-text">Best for large enterprises</div>
                                    </div>
                                  </div>
                                  <div class="pricing-price-pack-name-wrap">
                                    <div class="pricing-price">$520.00</div>
                                    <div class="pricing-pack-name">/ Per Month</div>
                                  </div>
                                  <div class="pricing-features-wrapper">
                                    <ul role="list" class="pricing-features-list">
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">1 page with multiple sections</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">3 — 10 days turnaround</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">First sketch in 24 hours</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Figma Design + Development</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Responsive (4 breakpoints)</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">SEO-optimized</div>
                                      </li>
                                      <li class="pricing-features-list-item"><img loading="lazy"
                                        src="images/pricing-20features-20list-20item-20icon.svg" alt=""
                                        class="pricing-features-list-item-icon" />
                                        <div class="pricing-features-list-item-text">Unlimited Stock Graphics</div>
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="pricing-features-button-wrapper">
                                    <div class="primary-button-wrapper pricing"><a href="/product/enterprise-plan"
                                      class="inner-button pricing w-inline-block">
                                      <div class="primary-button-border-wrap">
                                        <div class="inner-button-wrap">
                                          <div class="inner-button-text-wrap">
                                            <div class="inner-button-text">Get started now</div>
                                            <div class="inner-button-hover-text">Get started now</div>
                                          </div>
                                          <div class="inner-button-star-wrap"><img loading="lazy"
                                            src="images/inner-button-star-1.svg" alt=""
                                            class="inner-button-star _1" /><img loading="lazy"
                                              src="images/inner-button-star-2.svg" alt=""
                                              class="inner-button-star _2" /><img loading="lazy"
                                                src="images/inner-button-star-3.svg" alt=""
                                                class="inner-button-star _3" /></div>
                                          <div class="inner-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div class="line-wrap-inner">
                                        <div class="inner-line-wrap _1">
                                          <div class="line"></div>
                                          <div class="line _2"></div>
                                        </div>
                                        <div class="inner-line-wrap _2">
                                          <div class="line _3"></div>
                                          <div class="line _4"></div>
                                        </div>
                                        <div class="inner-line-wrap _3">
                                          <div class="line _5"></div>
                                          <div class="line _6"></div>
                                        </div>
                                        <div class="inner-line-wrap _4">
                                          <div class="line _7"></div>
                                          <div class="line _8"></div>
                                        </div>
                                      </div>
                                    </a></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d72e" class="section cta">

        {/* <div class="container">
          <div class="cta-content">
            <div data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d731" class="cta-typography">
              <div class="cta-title-description">
                <h2 class="cta-title">Embrace the future of Web3 and Blockchain.</h2>
                <p class="cta-description-text">Highly scalable, fast and secure blockchain platform for distributed apps,
                  enterprise use cases.</p>
              </div>
              <div class="cta-button-wrapper">
                <div class="primary-button-wrapper"><a href="/pricing" aria-current="page"
                  class="inner-button w-inline-block w--current">
                  <div class="primary-button-border-wrap">
                    <div class="inner-button-wrap">
                      <div class="inner-button-text-wrap">
                        <div class="inner-button-text">Get started now</div>
                        <div class="inner-button-hover-text">Get started now</div>
                      </div>
                      <div class="inner-button-star-wrap"><img loading="lazy" src="images/inner-button-star-1.svg"
                        alt="" class="inner-button-star _1" /><img loading="lazy" src="images/inner-button-star-2.svg"
                          alt="" class="inner-button-star _2" /><img loading="lazy" src="images/inner-button-star-3.svg"
                            alt="" class="inner-button-star _3" /></div>
                      <div class="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div class="line-wrap-inner">
                    <div class="inner-line-wrap _1">
                      <div class="line"></div>
                      <div class="line _2"></div>
                    </div>
                    <div class="inner-line-wrap _2">
                      <div class="line _3"></div>
                      <div class="line _4"></div>
                    </div>
                    <div class="inner-line-wrap _3">
                      <div class="line _5"></div>
                      <div class="line _6"></div>
                    </div>
                    <div class="inner-line-wrap _4">
                      <div class="line _7"></div>
                      <div class="line _8"></div>
                    </div>
                  </div>
                </a></div>
              </div>
            </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
              class="cta-top-left-element" /><img src="images/features-20card-20shape-20top-20right.svg" loading="lazy"
                alt="" class="cta-top-right-element" /><img src="images/cta-20botton-20left-20element.svg" loading="lazy"
                  alt="" class="cta-bottom-left-element" /><img src="images/cta-20botton-20right-20element.svg" loading="lazy"
                    alt="" class="cta-bottom-right-element" /><img src="images/cta-20shape.webp" loading="lazy"
                      data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d752" sizes="(max-width: 537px) 100vw, 537px" alt=""
                      srcset="images/cta-2520shape-p-500.png 500w, images/cta-20shape.webp 537w" class="cta-shape" /><img
              src="images/cta-20elment1.webp" loading="lazy" data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d753" alt=""
              class="cta-elment-one" /><img src="images/cta-20elment2.webp" loading="lazy"
                data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d754" alt="" class="cta-elment-two" />
          </div>
        </div> */}

      </section>
      <Footer />
    </div>
  )

};

export default Pricing; 